// 📁 src/pages/MarketResearch/FrameworkSelector.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { useIdea } from "../../context/IdeaContext";

const frameworks = [
  { key: "swot", name: "SWOT Analysis", path: "/market-research/swot" },
  { key: "tam-sam-som", name: "TAM-SAM-SOM", path: "/market-research/tam-sam-som" },
  { key: "lean-canvas", name: "Lean Canvas", path: "/market-research/lean-canvas" },
  { key: "porter", name: "Porter’s Five Forces", path: "/market-research/porter" },
  { key: "jtbd", name: "JTBD (Jobs To Be Done)", path: "/market-research/jtbd" },
  { key: "pestel", name: "PESTEL Analysis", path: "/market-research/pestel" },
];

const FrameworkSelector = ({
  ideaId: propIdeaId,
  idea: propIdeaText,
  recordId: propRecordId,
  recommended = [],
}) => {
  const navigate = useNavigate();
  const { selectedIdea } = useIdea();

  /* ---------------------------------------------------------
      🧠 1. Resolve final ideaId / ideaText / recordId source
         Priority:
         1️⃣ props (from MarketResearch)
         2️⃣ selectedIdea (IdeaContext)
         3️⃣ localStorage fallback
  --------------------------------------------------------- */
  const saved = (() => {
    try {
      return JSON.parse(localStorage.getItem("latestMarketResearch") || "{}");
    } catch {
      return {};
    }
  })();

  const ideaId =
    propIdeaId ||
    selectedIdea?.ideaId ||
    saved.ideaId ||
    null;

  const ideaText =
    propIdeaText ||
    selectedIdea?.description ||
    selectedIdea?.title ||
    saved.ideaText ||
    "";

  const recordId =
    propRecordId ||
    saved.recordId ||
    null;

  /* ---------------------------------------------------------
      🟦 2. Handler when user selects framework
  --------------------------------------------------------- */
  const handleSelect = (fw) => {
    if (!ideaId || !recordId) {
      alert("⚠️ Missing ideaId or market research record. Please run 5P Analysis first.");
      return;
    }

    navigate(fw.path, {
      state: {
        ideaId,
        ideaText,
        marketResearchRecordId: recordId,
      }
    });
  };

  /* ---------------------------------------------------------
      🟩 UI Render
  --------------------------------------------------------- */
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">🧠 Choose a Market Research Framework</h2>

      <div className="grid md:grid-cols-2 gap-4">
        {frameworks.map((fw) => {
          const isRecommended =
            recommended.includes(fw.name) ||
            recommended.includes(fw.key.toUpperCase());

          return (
            <div
              key={fw.key}
              onClick={() => handleSelect(fw)}
              className={`cursor-pointer border p-4 rounded-lg shadow-sm bg-white hover:shadow-md transition relative ${
                isRecommended ? "border-blue-500 ring-2 ring-blue-300" : ""
              }`}
            >
              <div className="text-lg font-semibold">{fw.name}</div>

              {isRecommended && (
                <span className="absolute top-2 right-2 bg-blue-600 text-white text-xs px-2 py-0.5 rounded-full">
                  Recommended
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FrameworkSelector;
